<template lang="pug">
#tabela-cars-inseridos-no-contrato
    .tabela-cars-inseridos-no-contrato-titulo-listagem
        h1 {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.titulo') }}
        el-tooltip(
            effect='dark',
            :content='$t("mensagens.subEmpresaGestao.tabelaCarsInseridosNoContrato.recarregarTabela")',
            placement='top',
            v-if='btnRecarregar'
        )
            el-button(
                type='info',
                icon='el-icon-refresh',
                size='mini',
                @click.native='atualizarTabela'
            )

    el-table(
        :key="listagemTableKey('cars-contrato', territoriosNaoEnviados, paginacao.pagina + 1)",
        :data='territoriosNaoEnviados',
        stripe,
        style='width: 100%',
        v-loading='carregando',
        @sort-change='sortChangeRequest',
        @selection-change='handleSelectionChange'
    )
        el-table-column(type='expand', width='25', align='center')
            .template(slot-scope='scope')
                .representantes-list-row
                    .representantes(
                        v-for='representante in scope.row.resumoDiagnosticoRepresentantes',
                        :key='representante.cpfCnpj'
                    )
                        p {{ representante.nome }} - {{ representante.cpfCnpj }}

                .cars-alerta-bloco
                    el-alert(
                        v-for='(alerta, index) in scope.row.alertas',
                        :key='index',
                        :title='alerta',
                        type='warning',
                        show-icon,
                        :closable='false'
                    )
                .link-modal-analise-eligibilidade(
                    v-if='(scope.row.statusCodigo === "PROCESSADO" || scope.row.statusCodigo === "LAUDO_EM_PROCESSAMENTO") && scope.row.statusCodigo !== "AGUARDANDO"'
                )
                    p {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analiseDeElegibilidade') }}
                    span.link-detalhes(
                        @click='visualizarAnaliseElegibilidade(scope.row)'
                    ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.verDetalhes') }}

        el-table-column#remover-territorio-nao-enviado(
            type='selection',
            :selectable='camposSelecionaveis',
            align='center'
        )
        el-table-column(
            v-if='this.usuarioLogado.ambienteLogado !== "PY"',
            prop='resumoDiagnosticoTerritorio.imovel.codigo',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.car")'
        )
        el-table-column(
            v-if='this.usuarioLogado.ambienteLogado === "PY"',
            prop='resumoDiagnosticoTerritorio.imovel.codigo',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documentoPY")'
        )
        el-table-column(
            v-if='this.usuarioLogado.ambienteLogado === "PY"',
            prop='resumoDiagnosticoTerritorio.imovel.codigo',
            label='RUC'
        )

        el-table-column(
            prop='cpfCnpj',
            v-if='this.usuarioLogado.ambienteLogado !== "PY"',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.documento")'
        )
            .template(slot-scope='scope')
                .representantes(
                    v-if='scope.row.territorioRepresentantes && scope.row.territorioRepresentantes.length > 0'
                )
                    p.representantes-hidden-row
                        | {{ scope.row.territorioRepresentantes?.[0].cpfCnpj ? scope.row.territorioRepresentantes?.[0].cpfCnpj : '-' }}
                        el-tag.ml-2(
                            v-if='scope.row.territorioRepresentantes?.length > 1',
                            size='mini'
                        )
                            | + {{ scope.row.territorioRepresentantes?.length - 1 }}

        el-table-column(
            v-if='this.usuarioLogado.ambienteLogado !== "PY"',
            prop='volume',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.volumeInformado")'
        )
            .template(slot-scope='scope')
                span {{ scope.row.volume ? `${scope.row.volume} t` : '-' }}
        
        el-table-column(
            v-if='isSubproduto',
            prop='volumeMaterialOrigem',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.volumeMaterialOrigem")'
        )
            .template(slot-scope='scope')
                span {{ scope.row.volumeMaterialOrigem ? `${scope.row.volumeMaterialOrigem} t` : '-' }}

        el-table-column(
            prop='statusElegibilidade',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.analiseElegibilidade")'
        )
            .template(slot-scope='scope')
                .status-elegibilidade-tabela-cars
                    div(
                        v-if='scope.row.statusCodigo === "LAUDO_EM_PROCESSAMENTO"'
                    )
                        el-tooltip(
                            placement='top',
                            :content='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.laudoMensagemElegibilidade")'
                        )
                            span
                                i.mdi.mdi-information.font-size-mdi.mr-2
                                span {{ scope.row.status }}

                    div(
                        v-if='scope.row.codigoStatusElegibilidade === "ELEGIVEL" && scope.row.statusCodigo !== "LAUDO_EM_PROCESSAMENTO"'
                    )
                        span.status-elegibilidade-tabela-cars__bloco.status-sucess
                            i.mdi.mdi-check-circle-outline.mr-2
                            span {{ scope.row.statusElegibilidade }}

                    div(
                        v-if='scope.row.codigoStatusElegibilidade === "INELEGIVEL" && scope.row.statusCodigo !== "LAUDO_EM_PROCESSAMENTO"'
                    )
                        span.status-elegibilidade-tabela-cars__bloco.status-danger
                            i.mdi.mdi-close-circle-outline.mr-2
                            span {{ scope.row.statusElegibilidade }}

                    div(
                        v-if='scope.row.codigoStatusElegibilidade === "ALERTA" && scope.row.nivelAlertaRastreabilidade === "MEDIO_ALTO" && scope.row.statusCodigo !== "LAUDO_EM_PROCESSAMENTO"'
                    )
                        span.status-elegibilidade-tabela-cars__bloco.status-laranja
                            i.flow.flow-warning-sign.mr-1
                            span {{ scope.row.statusElegibilidade }}

                    div(
                        v-if='scope.row.codigoStatusElegibilidade === "EM_PROCESSAMENTO" && scope.row.statusCodigo !== "LAUDO_EM_PROCESSAMENTO"'
                    )
                        span.status-elegibilidade-tabela-cars__bloco
                            i.el-icon-loading.mr-2
                            span {{ scope.row.statusElegibilidade }}
                    div(
                        v-if='scope.row.codigoStatusElegibilidade === "ERRO_PROCESSAR"'
                    )
                        span.status-elegibilidade-tabela-cars__bloco
                            i.el-icon-refresh-right.mr-2
                            span {{ scope.row.statusElegibilidade }}

        el-table-column(
            prop='dataElegibilidade',
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.dataUltimaAnalise")'
        )
            .template(slot-scope='scope')
                span {{ scope.row.dataElegibilidade }}

        el-table-column(
            :label='$t("mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acao")',
            align='center'
        )
            .template(slot-scope='scope')
                el-dropdown.action-button
                    i.mdi.mdi-dots-vertical
                    el-dropdown-menu(slot='dropdown')
                        el-dropdown-item(
                            icon='el-icon-edit',
                            :disabled='!codigoStatusSubEmpresaPermiteAlteracao.includes(statusSubEmpresaCodigo) || !codigoStatusDiagnosticoPermiteAlteracao.includes(scope.row.statusCodigo)',
                            @click.native='editarVolume(scope.row)'
                        ) {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acoes.editarVolume') }}

                        el-dropdown-item(
                            icon='el-icon-view',
                            @click.native='visualizarAnaliseElegibilidade(scope.row)',
                            v-if='(scope.row.statusCodigo === "PROCESSADO" || scope.row.statusCodigo === "LAUDO_EM_PROCESSAMENTO") && scope.row.statusCodigo !== "AGUARDANDO"'
                        ) {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acoes.visualizarAnaliseElegebilidade') }}

                        el-dropdown-item(
                            icon='el-icon-refresh',
                            v-if='scope.row.codigoStatusElegibilidade === "ALERTA" && scope.row.nivelAlertaRastreabilidade === "MEDIO_ALTO" && scope.row.idLaudo === null && !isAlvorada',
                            :disabled='scope.row.statusCodigo === "LAUDO_EM_PROCESSAMENTO" || scope.row.statusCodigo === "AGUARDANDO"',
                            @click.native='exibirModalSolicitacaoLaudo(scope.row)'
                        ) {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acoes.solicitarLaudoElegibilidade') }}

                        el-dropdown-item(
                            v-if='scope.row.nivelAlertaRastreabilidade === "MEDIO_ALTO" && scope.row.analiseStatus !== null && !isAlvorada',
                            :disabled='!scope.row.analiseStatus',
                            :icon='analiseStatusIcone[scope.row.analiseStatus]',
                            @click.native='respostaAnaliseEmpresa(scope.row)'
                        ) {{ scope.row.analiseStatus ? $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.visualizarResposta') : $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.AguardarResposta') }}

                        el-dropdown-item(
                            icon='el-icon-download',
                            v-if='scope.row.idLaudo !== null && !isAlvorada',
                            :disabled='scope.row.statusCodigo === "EM_PROCESSAMENTO" || scope.row.statusCodigo === "LAUDO_EM_PROCESSAMENTO"',
                            @click.native='downloadLaudo(scope.row)'
                        ) {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acoes.baixarLaudo') }}

                        el-dropdown-item(
                            icon='el-icon-delete',
                            :disabled='!codigoStatusSubEmpresaPermiteAlteracao.includes(statusSubEmpresaCodigo) || !codigoStatusDiagnosticoPermiteAlteracao.includes(scope.row.statusCodigo)',
                            @click.native='removerTerritorio(scope.row)'
                        ) {{ $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.acoes.remover') }}

    .tabela-gestao-contrato-originacao__paginacao
        .spans-paginacao
            span.pagina
                | {{ paginacao.total }} {{ paginacao.total <= 1 ? $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.territorio') : $t('mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.territorios') }}

            //- span.volume-disponivel
                | {{ formatarTonelada(volumeDisponivelContrato) }} volume disponível (t)

        el-pagination(
            background,
            :page-size='paginacao.itensPorPagina',
            :pager-count='5',
            :current-page.sync='paginacao.pagina',
            layout='prev, pager, next',
            :total='paginacao.total',
            @current-change='mudarPagina'
        )

    .modal-responder-analise
        ModalResponderAnalise(
            :show='mostrarModalResponderAnalise',
            :layout='interfaceUsuario',
            :solicitacao='territorioSelecionado',
            @handleCloseModalResponderAnalise='handleCloseModalResponderAnalise',
            :visualizarResposta='visualizarResposta'
        )
    div
        ModalSolicitacaoLaudo(
            :show='showModalSolicitacaoLaudo',
            :possuiPontoAreaEmbargada='possuiPontoAreaEmbargada',
            :idTerritorioSelecionado='idTerritorioSelecionado',
            :carSelecionado='carSelecionado',
            @closeModalSolicitacaoLaudo='closeModalSolicitacaoLaudo',
            @atualizarTabela='atualizarTabela'
        )
</template>

<script>
import formatters from '@/utils/formatters';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import ModalResponderAnalise from '@/components/contratosOriginacao/ModalResponderAnalise.vue';
import LaudosService from '@/services/LaudosService';
import ModalSolicitacaoLaudo from '@/components/contratosOriginacao/ModalSolicitacaoLaudo.vue';
import { mapGetters } from 'vuex';

export default {
    name: 'TabelaCarsInseridosNoContrato',
    components: {
        ModalResponderAnalise,
        ModalSolicitacaoLaudo
    },

    props: {
        dados: {
            type: Object,
            required: false
        },
        territoriosNaoEnviados: {
            type: Array,
            required: true
        },
        removendo: {
            type: Boolean,
            required: false
        },
        volumeDisponivelContrato: {
            type: Number,
            required: true
        },
        paginacao: {
            type: Object,
            required: true
        },
        carregando: {
            type: Boolean,
            required: false
        },
        btnRecarregar: {
            type: Boolean,
            required: false,
            default: false
        },
        statusSubEmpresaCodigo: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            analiseStatusIcone: {
                false: 'el-icon-chat-dot-round',
                true: 'el-icon-view'
            },
            interfaceUsuario: 'revenda',
            visualizarResposta: true,
            territorioSelecionado: {
                nomeTerritorio: null,
                analiseDataSolicitacao: null,
                analiseDataResposta: null,
                statusAnalise: null
            },
            mostrarModalResponderAnalise: false,
            possuiPontoAreaEmbargada: false,
            showModalSolicitacaoLaudo: false,
            idTerritorioSelecionado: null,
            carSelecionado: null,
            codigoStatusSubEmpresaPermiteAlteracao: [
                'EM_CADASTRAMENTO',
                'AGUARDANDO_PREENCHIMENTO',
                'EM_ANDAMENTO_VOLUME_INCONPLETO',
                'EM_ANDAMENTO_REQUER_ATENCAO',
                'EM_ANDAMENTO_AGUARDANDO_ENVIO',
                'EM_ANDAMENTO',
                'DISCREPANCIA',
                'AJUSTADO_PELA_REVENDA'
            ],
            codigoStatusDiagnosticoPermiteAlteracao: ['PROCESSADO']
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado', 'isAlvorada']),
        isSubproduto() {
            return this.dados?.isSubproduto || false;
        }
    },

    methods: {
        editarVolume(row) {
            this.$emit('editarVolume', row);
        },

        handleSelectionChange(territorios) {
            this.$emit('removerTerritorioLote', territorios);
            this.elegibilidade(territorios);
        },

        elegibilidade(territorios) {
            this.$emit('realizarElegibilidade', territorios);
        },

        mudarPagina(novaPagina) {
            this.$emit('mudarPagina', novaPagina - 1);
        },

        sortChangeRequest(column) {
            this.$emit('ordenarTabela', column);
        },

        formatarTonelada(valor) {
            return formatters.formatNumber(valor, 2);
        },
        async removerTerritorio(territorio) {
            try {
                let result = false;

                result = await this.$messageBox.confirm(
                    `O CAR ${
                        territorio.resumoDiagnosticoTerritorio.imovel.codigo
                    } ${this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.excluir'
                    )}`,
                    this.$t(
                        'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.aviso'
                    ),
                    {
                        confirmButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.confirmar'
                        ),
                        cancelButtonText: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.avisos.cancelar'
                        ),
                        type: 'warning'
                    }
                );
                if (result) {
                    const resultado =
                        await ContratoOriginacaoServiceSubEmpresa.removerTerritorioContratoSubEmpresa(
                            this.$route.params.numeroContrato,
                            territorio.idTerritorio,
                            territorio.resumoDiagnosticoTerritorio.imovel.codigo
                        );
                    this.$notify.success({
                        message: resultado.data
                    });
                    this.$emit('territorioRemovido');
                    this.$emit(
                        'removerTerritorioBlocoInserirContratoUploadPlanilha',
                        territorio.resumoDiagnosticoTerritorio.imovel.codigo
                    );
                }
            } catch (erro) {
                this.$notify.error({
                    message: erro.response.data.message
                });
            }
        },
        async removerTerritoriosEmLote(territorios) {
            for (let territorio of territorios) {
                await ContratoOriginacaoServiceSubEmpresa.removerTerritorioContratoSubEmpresa(
                    this.$route.params.numeroContrato,
                    territorio.idTerritorio,
                    territorio.resumoDiagnosticoTerritorio.imovel.codigo
                );
            }
        },
        camposSelecionaveis(row, index) {
            const selecionavel =
                row.statusCodigo !== 'LAUDO_EM_PROCESSAMENTO' &&
                row.statusElegibilidade !== 'Em processamento' &&
                this.statusSubEmpresaCodigo !== 'CONCLUIDO';
            return selecionavel;
        },
        async salvarAnaliseEmpresa(row) {
            try {
                const mesg =
                    await ContratoOriginacaoServiceSubEmpresa.solicitarAnaliseTerritorioInconformeEmpresa(
                        {
                            numeroContrato: this.$route.params.numeroContrato,
                            idTerritorio: row.idTerritorio,
                            codigoCar:
                                row.resumoDiagnosticoTerritorio.imovel.codigo
                        }
                    );

                this.$notify.success({
                    message: mesg.data
                });

                this.atualizarTabela();
            } catch (e) {
                this.$notify.error({
                    message: e.response.data.message
                });
            }
        },
        respostaAnaliseEmpresa(solicitacao) {
            if (
                this.interfaceUsuario === 'empresa' &&
                solicitacao.statusAnalise === true
            ) {
                this.visualizarResposta = true;
            }
            this.territorioSelecionado = solicitacao;
            this.mostrarModalResponderAnalise = true;
        },
        handleCloseModalResponderAnalise() {
            this.visualizarResposta = false;
            this.mostrarModalResponderAnalise = false;
        },
        async downloadLaudo(item) {
            if (item.idLaudo !== null) {
                try {
                    await LaudosService.downloadLaudo(item.idLaudo);
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.downloadLaudo.download'
                        )
                    });
                } catch (error) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.tabelacarsinseridosnocontrato.downloadLaudo.downloadErro'
                        )
                    });
                }
            }
        },
        visualizarAnaliseElegibilidade(row) {
            this.$emit('visualizarAnaliseElegibilidade', row);
        },
        atualizarTabela() {
            this.$emit('atualizarTabela');
        },
        async exibirModalSolicitacaoLaudo(car) {
            this.possuiPontoAreaEmbargada = car.possuiPontoAreaEmbargada;
            this.showModalSolicitacaoLaudo = true;
            this.idTerritorioSelecionado = car.idTerritorio;
            this.carSelecionado = car.resumoDiagnosticoTerritorio.imovel.codigo;
        },
        closeModalSolicitacaoLaudo() {
            this.showModalSolicitacaoLaudo = false;
            this.idTerritorioSelecionado = null;
            this.carSelecionado = null;
        }
    }
};
</script>

<style lang="scss">
#tabela-cars-inseridos-no-contrato {
    h1,
    .el-checkbox {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
        background: transparent;
    }

    .el-checkbox {
        display: block;
    }

    .el-table {
        border-top-right-radius: 11px;
        border-top-left-radius: 11px;
        min-height: 240px;

        thead.has-gutter {
            height: 67px;

            th.el-table__cell {
                background-color: #fbfbfb;
            }
        }

        .descricao-item-tabela {
            margin-left: 55px;
            margin-right: 55px;
        }

        .el-table .cell .el-checkbox__inner {
            padding: 0px;
        }
    }

    .el-table__cell {
        font-size: 12px;
    }

    .is-leaf {
        font-size: 13px;
    }

    .el-table .cell {
        word-break: normal;
    }

    .representantes-list-row {
        display: grid;
        grid-template-columns: auto auto auto;
        width: 100%;
        column-gap: 10px;
    }

    .cars-alerta-bloco {
        .el-alert__title {
            color: #3b3b3b !important;
        }
    }

    .link-modal-analise-eligibilidade {
        display: flex;
        margin-top: 19px;
        font-size: 13px;
        color: #3b3b3b;

        .link-detalhes {
            color: #1989fa;
            margin-left: 5px;
            cursor: pointer;
        }
    }

    .representantes {
        display: flex;
    }

    .representantes-hidden-row {
        max-width: 55ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .el-descriptions-item__container .el-descriptions-item__content {
        display: flex;
        flex-direction: column;
        column-count: 3;
    }

    .el-table td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #e9ecef;
    }

    .tabela-gestao-contrato-originacao__paginacao {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--white);
        padding: 14px 11px;
        border-bottom-left-radius: 11px;
        border-bottom-right-radius: 11px;

        .pagina,
        .volume-disponivel {
            color: var(--primary);
            font-weight: 600;
        }

        .spans-paginacao {
            display: flex;
            gap: 21px;
        }
    }

    .el-descriptions-item__label.has-colon::after {
        content: '' !important;
    }

    .el-checkbox__inner {
        margin-left: -10px;
    }

    .tabela-cars-inseridos-no-contrato-titulo-listagem {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
    }
}

.status-elegibilidade-tabela-cars {
    .status-elegibilidade-tabela-cars__bloco {
        display: flex;
        align-items: center;

        i.mdi {
            font-size: 18px;
            font-size: 18px;
        }

        i.flow {
            font-size: 15px;
        }

        .el-icon-loading {
            font-size: 18px;
        }

        .el-icon-refresh-right {
            font-size: 18px;
            cursor: pointer;
        }
    }

    .status-amarelo {
        color: #bfae19;
    }

    .status-laranja {
        color: var(--warning);
    }

    .status-danger {
        color: var(--danger);
    }

    .status-sucess {
        color: var(--green);
    }
}
</style>
